import { useLanguage } from "@/lib/LanguageContext";
import { Wrench, Cpu, Disc3, Droplets, Cog, ArrowUpDown, Zap, Thermometer, Shield } from "lucide-react";

const serviceIcons = [Wrench, Cpu, Disc3, Droplets, Cog, ArrowUpDown, Zap, Thermometer, Shield];

export const Services = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-32 relative" style={{ background: '#081f33' }}>
      <div className="absolute inset-0 noise-overlay" />
      <div className="relative z-10 container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header */}
        <div className="mb-16">
          <span className="text-teal text-xs tracking-[0.4em] uppercase font-body font-semibold mb-4 block">
            {t.services.subtitle}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl tracking-wide uppercase font-bold text-white">
            {t.services.title}
          </h2>
          <div className="w-20 h-[3px] bg-gold mt-6" />
        </div>

        {/* Service Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.services.items.map((service, i) => {
            const Icon = serviceIcons[i];
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="group relative bg-navy-paper border border-white/5 hover:border-gold/30 transition-all duration-500 overflow-hidden p-8 flex flex-col"
              >
                <div className="service-card-line" />

                <Icon className="w-8 h-8 text-gold mb-5 group-hover:text-teal transition-colors duration-500" strokeWidth={1.5} />
                <h3 className="font-heading text-xl tracking-wider uppercase text-white mb-3 group-hover:text-gold transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="font-body text-sm text-slate-400 leading-relaxed mb-4 flex-1">
                  {service.description}
                </p>

                {/* Benefits */}
                <div className="flex flex-wrap gap-2 mb-5">
                  {service.benefits.split(", ").map((b, j) => (
                    <span key={j} className="text-[10px] tracking-wider uppercase font-body text-teal/80 border border-teal/15 px-2 py-0.5">
                      {b}
                    </span>
                  ))}
                </div>

                <button
                  onClick={scrollToContact}
                  className="text-xs tracking-[0.15em] uppercase font-heading font-bold text-gold hover:text-gold-light transition-colors duration-300 text-left"
                >
                  {t.services.cta} &rarr;
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
